module.exports = __webpack_public_path__ + "img/5d.3a34b73d.png";